import { render, staticRenderFns } from "./PagePayouts.vue?vue&type=template&id=6e869288&"
import script from "./PagePayouts.vue?vue&type=script&lang=js&"
export * from "./PagePayouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports